// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum CreditExposureState {
  Valid = "VALID",
  Expired = "EXPIRED",
  Canceled = "CANCELED",
  ValidInFuture = "VALID_IN_FUTURE",
}
export default CreditExposureState;
